import {
  IconBank,
  IconFileText,
  IconPollOutline,
  IconWallet,
} from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { LayoutHeadings } from 'components/Layout/InnerLayout/LayoutHeadings/LayoutHeadings';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { FeatureHighlight } from '../../FeatureHighlight/FeatureHighlight';
import sharedStyles from '../../Products.module.css';
import styles from './MinimumCriteriaDE.module.css';

type TProps = {
  onApply: () => void;
};

export const MinimumCriteriaDE = ({ onApply }: TProps) => {
  const { checkIntroducerPermission } = useIntroducerData();

  return (
    <div className={clsx(sharedStyles.section, styles.container)}>
      <LayoutHeadings
        heading={t`Minimum criteria`}
        headingVariant="long"
        headingAlignment="center"
      />

      <div className={sharedStyles.highlights}>
        <FeatureHighlight
          icon={IconBank}
          feature={t`Headquartered in Germany`}
        />
        <FeatureHighlight
          icon={IconWallet}
          feature={t`More than 22,000 € annual revenue`}
        />
        <FeatureHighlight
          icon={IconFileText}
          feature={t`Operating for at least 2 months**`}
        />
        <FeatureHighlight
          icon={IconPollOutline}
          feature={t`Crefo score up to 333`}
        />
      </div>

      <p className={styles.footnote}>
        <Trans>
          ** For terms of 36, 48 and 60 months, the company age must be at least
          equal to the requested loan term.
        </Trans>
      </p>

      <div className={styles.cta}>
        <Button
          variant="primary"
          disabled={!checkIntroducerPermission('can_create_applications')}
          onClick={onApply}
        >
          <Trans>Create a new app</Trans>
        </Button>
      </div>
    </div>
  );
};
